/*
 *
 * ForgotPasswordPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import withRouter from 'withRouter';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { passwordResetRequestRequest,
  passwordResetRequest,
  requestAnother,
  setComponentToPasswordReset,
  setComponentToInvalidPasswordReset,
  resetForgotPageState
} from './actions';
import { selectComponentToRender } from './selectors';
import {
  Wrapper,
  Heading,
  Msgtext,
  BacktoSignin,
  ButtonWrapper,
  Container,
} from './styledComponents';

import { toast } from 'sonner';
import { t } from 'copy/t';
import RequestForm from './RequestForm';
import Form from './Form';
import H1 from 'components/H1';

class ForgotPasswordPage extends React.Component {
  componentDidMount () {
    if (this.props.location.search.match(/reset_password_token=([^&]*)/)) {
      this.props.setComponentToPasswordReset();
    }
    if (this.props.location.search.match(/update_password_token=([^&]*)/)) {
      this.props.setComponentToInvalidPasswordReset();
    }
  }

  render () {
    const {
      openInvalidPasswordModal,
      openPasswordRequirementsModal,
      onPasswordResetRequestSubmit,
      onPasswordResetSubmit,
      componentToRender,
      location,
      resetState,
      invalidPasswordEmail
    } = this.props;

    const resetToken =
      location.search.match(/reset_password_token=([^&]*)/)
      ? location.search.match(/reset_password_token=([^&]*)/)[1]
      : location.search.match(/update_password_token=([^&]*)/) ? location.search.match(/update_password_token=([^&]*)/)[1] :'';

    return (
      <Wrapper>
        <HelmetProvider>
          <Helmet title='Movebooth | Forgot Password' />
        </HelmetProvider>
          {
            {
              REQUEST_SUCCESS:
                <Heading>
                  <H1>
                    📫 Check your email.
                  </H1>
                  <Msgtext>
                    If we have an account for the email address you entered, you’ll receive an email with instructions to reset your password. If you don’t receive it within about 5 minutes, request another email.
                  </Msgtext>
                  <BacktoSignin>
                     <Link to='/sign-in' onClick={() => resetState()}>
                      Back to Sign In
                    </Link>
                  </BacktoSignin>
                </Heading>,
              REQUEST_FORM:
                <Container>
                  <Heading>
                    <H1>
                    🤔 Forgotten password?
                    </H1>
                    <Msgtext>Don’t sweat it! Enter your email address and we’ll help reset it.</Msgtext>
                  </Heading>
                  <RequestForm onSubmit={onPasswordResetRequestSubmit} />
                </Container>,
              PASSWORD_RESET_FORM:
                <Container>
                  <Heading>
                    <H1>
                    🔒 Enter new password.
                    </H1>
                    <Msgtext>Set yourself a new password. And be sure to save it in your favorite password management app! Future you will thank you. :)</Msgtext>
                  </Heading>
                  <Form
                    initialValues={{ reset_password_token: resetToken }}
                    onSubmit={onPasswordResetSubmit}
                    openInvalidPasswordModal={openInvalidPasswordModal}
                    openPasswordRequirementsModal={openPasswordRequirementsModal}
                  />
                </Container>,
              INVALID_PASSWORD_RESET_FORM:
                <Container>
                  <Heading>
                    <H1>
                    🔒 Password Update Required
                    </H1>
                    <Msgtext>In order to keep your account safe, we need you to go ahead and create a new secure password</Msgtext>
                  </Heading>
                  <Form
                    initialValues={{ reset_password_token: resetToken, email: invalidPasswordEmail }}
                    onSubmit={onPasswordResetSubmit}
                    email={invalidPasswordEmail}
                    openInvalidPasswordModal={openInvalidPasswordModal}
                    openPasswordRequirementsModal={openPasswordRequirementsModal}
                  />
                </Container>,
              REDIRECT_TO_SIGN_IN:
                  <Heading>
                    <H1>
                      Your Password is updated.
                    </H1>
                    <Msgtext>You have successfully updated your password. You can now sign in with your new password.</Msgtext>
                  <BacktoSignin>
                    <ButtonWrapper>
                    <Link to='/sign-in' onClick={() => resetState()}>
                      Back to Sign In
                    </Link>
                    </ButtonWrapper>
                  </BacktoSignin>
                  </Heading>
            }[componentToRender]
        }
      </Wrapper>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  componentToRender: selectComponentToRender(),
});

const mapDispatchToProps = (dispatch) => ({
  onPasswordResetRequestSubmit: (data) =>
    dispatch(passwordResetRequestRequest(data)),

  onPasswordResetSubmit: (data) =>
    dispatch(passwordResetRequest(data)),

  requestAnother: () =>
    dispatch(requestAnother()),

  openPasswordRequirementsModal: () =>
    toast.info(t('toast.passwordMinLengthHint')),

  openInvalidPasswordModal: () =>
    toast.error(t('toast.passwordMinLength')),

  setComponentToPasswordReset: () =>
    dispatch(setComponentToPasswordReset()),

  setComponentToInvalidPasswordReset: () =>
    dispatch(setComponentToInvalidPasswordReset()),

  resetState: () =>{
      return dispatch(resetForgotPageState())},
});

// `location` used to arrive from <Route render={props => ...}>, which v7
// removed — withRouter supplies it via useLocation instead.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ForgotPasswordPage));
